<layout-page-container>
  <!-- No `layout-header-container` on this page: the scroll area is the container's first child, so it owns the
       page's top gutter and must not draw a header/body separator under nothing (#235). -->
  <layout-page-scrollable [hasPageHeader]="false">
    <!-- #664: a virtual event has no orders, no summary and no export, so it gets its own page rather than
         this one rendered empty. The branch is here (not inside the page below) so none of the order-shaped
         markup — or the sub-flows it opens — exists for a virtual event at all. -->
    @if (event && event.kind === EventKind.Virtual) {
      <app-virtual-event-details [event]="event" [last]="last" (settingsRequested)="settings_redirect()"/>
    } @else if (event) {
      <div class="mx-auto w-full pb-8">
        <div class="grid grid-cols-1">
          <div class="flex w-full">
            @if (locationId == '' || !locationId) {
              <svg [routerLink]="['/' + Routes.LocationModule + '/' + LocationRoutes.Events]"
                [queryParams]="{ previous: event.id, last: last }"
                fragment="{{event.id}}" queryParamsHandling="merge" xmlns="http://www.w3.org/2000/svg" width="20"
                height="20"
                class="col-span-1 mr-2 self-center bi bi-arrow-left-circle hover:text-theme-primary-700 hover:cursor-pointer"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
              </svg>
            } @else {
              <svg [routerLink]="[]" [queryParams]="{ location: undefined }"
                queryParamsHandling="merge" xmlns="http://www.w3.org/2000/svg" width="20" height="20"

                class="col-span-1 mr-2 self-center bi bi-arrow-left-circle hover:text-theme-primary-700 hover:cursor-pointer"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
              </svg>
            }
            <div class="flex-grow"></div>
            <div class="isolate flex rounded-md col-span-12 md:col-span-2 divide-x">
              <!-- Jump to this event's shift plan. Gated on the same set as the navbar entry and the route, so
                   it never offers a door it cannot open. A ShiftLead (#280) now satisfies that set, which is a
                   deliberate no-op here rather than a special case: this page's own route is gated on
                   Permissions_EventDetailsComponent — legacy admin ids — so a shift lead never gets this far.
                   Left consistent so the button follows the route it links to if that ever changes. -->
              @if (PermissionService.CheckPermission(PermissionService.Permissions_ShiftMakerComponent())) {
                <button
                  [queryParams]="{event: event.id, date: event.start.toISOString()}"
                  [routerLink]="['/' + Routes.CompanyModule + '/' + CompanyRoutes.ShiftMaker]" class="menu-button"
                  type="button">
                  <svg class="bi bi-calendar3" height="20" viewBox="0 0 16 16" width="20"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/>
                    <path
                      d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                  </svg>
                </button>
              }

              @if (PermissionService.CheckPermission(PermissionService.Inventory_Event_GetEmployeeOrders())) {
                <button
                  (click)="employeeSales_open()"
                  class="menu-button"
                  type="button">
                  <svg class="bi bi-person-circle" height="20" viewBox="0 0 16 16"
                    width="20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                    <path
                      d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                      fill-rule="evenodd"/>
                  </svg>
                </button>
              }

              @if (PermissionService.CheckPermission(PermissionService.CombinedPermission_EventDownloadExtendedEvent())) {
                <button
                  (click)="supplierPopup_show()"
                  class="menu-button"
                  type="button">
                  <svg height="20" viewBox="0 0 256 256" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M240 136v64a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-64a16 16 0 0 1 16-16h40a8 8 0 0 1 0 16H32v64h192v-64h-40a8 8 0 0 1 0-16h40a16 16 0 0 1 16 16m-117.66-2.34a8 8 0 0 0 11.32 0l48-48a8 8 0 0 0-11.32-11.32L136 108.69V24a8 8 0 0 0-16 0v84.69L85.66 74.34a8 8 0 0 0-11.32 11.32ZM200 168a12 12 0 1 0-12 12a12 12 0 0 0 12-12"
                      />
                  </svg>
                </button>
              }

              @if (PermissionService.CheckPermission(PermissionService.CombinedPermission_EventReadLocationConfig())) {
                <button
                  (click)="locationConfig_open()"
                  class="menu-button"
                  type="button">
                  <svg class="bi bi-gear-wide-connected" height="20" viewBox="0 0 16 16"
                    width="20" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.068.727c.243-.97 1.62-.97 1.864 0l.071.286a.96.96 0 0 0 1.622.434l.205-.211c.695-.719 1.888-.03 1.613.931l-.08.284a.96.96 0 0 0 1.187 1.187l.283-.081c.96-.275 1.65.918.931 1.613l-.211.205a.96.96 0 0 0 .434 1.622l.286.071c.97.243.97 1.62 0 1.864l-.286.071a.96.96 0 0 0-.434 1.622l.211.205c.719.695.03 1.888-.931 1.613l-.284-.08a.96.96 0 0 0-1.187 1.187l.081.283c.275.96-.918 1.65-1.613.931l-.205-.211a.96.96 0 0 0-1.622.434l-.071.286c-.243.97-1.62.97-1.864 0l-.071-.286a.96.96 0 0 0-1.622-.434l-.205.211c-.695.719-1.888.03-1.613-.931l.08-.284a.96.96 0 0 0-1.186-1.187l-.284.081c-.96.275-1.65-.918-.931-1.613l.211-.205a.96.96 0 0 0-.434-1.622l-.286-.071c-.97-.243-.97-1.62 0-1.864l.286-.071a.96.96 0 0 0 .434-1.622l-.211-.205c-.719-.695-.03-1.888.931-1.613l.284.08a.96.96 0 0 0 1.187-1.186l-.081-.284c-.275-.96.918-1.65 1.613-.931l.205.211a.96.96 0 0 0 1.622-.434l.071-.286zM12.973 8.5H8.25l-2.834 3.779A4.998 4.998 0 0 0 12.973 8.5zm0-1a4.998 4.998 0 0 0-7.557-3.779l2.834 3.78h4.723zM5.048 3.967c-.03.021-.058.043-.087.065l.087-.065zm-.431.355A4.984 4.984 0 0 0 3.002 8c0 1.455.622 2.765 1.615 3.678L7.375 8 4.617 4.322zm.344 7.646.087.065-.087-.065z"/>
                  </svg>
                </button>
              }

              @if (PermissionService.CheckPermission(PermissionService.Inventory_Event_Get())) {
                <button (click)="settings_redirect()"
                  class="menu-button"
                  type="button">
                  <svg class="bi bi-gear-wide-connected" height="20" viewBox="0 0 16 16"
                    width="20" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"/>
                  </svg>
                </button>
              }
            </div>
          </div>
          <h1
            class="md:text-center pt-4 pb-4 flex-grow col-span-11 md:col-span-8 self-center font-semibold leading-6 text-gray-900 md:!text-3xl">
            {{ event.name }}{{ !location ? '' : ':&nbsp;' + location.name }}
            <br>
              <span class="fw-light !text-sm">Verbindungsstatus:
                <span (click)="connection?.start()"
                      [class.!text-green-700]="connection?.state == HubConnectionState.Connected"
                      [class.!text-red-600]="connection?.state == HubConnectionState.Disconnected"
                      [class.pointer-events-auto]="connection?.state == HubConnectionState.Disconnected"
                      [class.cursor-pointer]="connection?.state == HubConnectionState.Disconnected"
                      class="fw-normal place-self-center pl-2 text-yellow-400 pointer-events-none select-none">
                  {{ connection?.state }}
                </span>
              </span>
            </h1>
          </div>

          <div class="md:hidden grid grid-cols-1 gap-3">
            <!--
              #817: the phone's headline tile is the REVENUE and its reconciliation, the same figures the
              Z-Bericht prints. `@else` keeps the old „Gesamtumsatz" tile for a payload that carries no
              statistics at all (a pre-#817 server, a projection without `orderStats`).
            -->
            @if (EventHelper.getRevenue(event); as revenue) {
              <app-event-revenue-tile [revenue]="revenue"/>
            } @else {
              <div class="bg-white shadow-lg w-full rounded-lg">
                <div class="px-3 py-2">
                  <p class="text-gray-600 text-sm fw-bold">Gesamtumsatz</p>
                  <p class="text-2xl fw-bold">{{ EventHelper.getEventTotal(event) | currency: "EUR" }}</p>
                </div>
              </div>
            }
            <div class="bg-white shadow-lg w-full rounded-lg">
              <div class="grid grid-cols-2 divide-x divide-y">
                <div class="px-3 py-2">
                  <p class="text-gray-600 text-sm fw-bold">Artikel</p>
                  <div class="grid grid-cols-2">
                    <p>{{ EventHelper.getArticleCount(event) }}x</p>
                    <p
                    class="text-lg text-end">{{ EventHelper.getArticleTotal(event) | currency: "EUR" }}</p>
                  </div>
                </div>
                <div class="px-3 py-2">
                  <p class="text-gray-600 text-sm fw-bold">Sonstiges</p>
                  <div class="grid grid-cols-2">
                    <p>{{ EventHelper.getOtherCount(event) }}x</p>
                    <p
                    class="text-lg text-end">{{ EventHelper.getOtherTotal(event) | currency: "EUR" }}</p>
                  </div>
                </div>

              </div>
            </div>
          </div>


          <div class="rounded-md mx-auto hidden md:flex">
            <div class="mx-auto w-full">
              <div class="grid grid-cols-1 gap-px bg-white/5 sm:grid-cols-2 2xl:grid-cols-4 gap-3">
                <div class="bg-white shadow-lg px-4 py-3 sm:px-6 lg:px-8 rounded-lg w-full">
                  <p class="text-sm font-medium leading-6 text-gray-700 inline-flex">Sonstiges</p>
                  <p class="mt-2 grid grid-cols-2 items-baseline gap-x-2">
                    <span
                    class="text-3xl font-semibold 2xl:font-light tracking-tight text-gray-900">{{ EventHelper.getOtherTotal(event) | currency: "EUR" }}</span>
                    <span
                      class="text-3xl font-semibold 2xl:font-light tracking-tight text-gray-900 justify-self-end">{{ EventHelper.getOtherCount(event) }}
                    x</span>
                  </p>
                </div>
                <div class="bg-white shadow-lg px-4 py-3 sm:px-6 lg:px-8 rounded-lg">
                  <p class="text-sm font-medium leading-6 text-gray-700 inline-flex">Artikel</p>
                  <p class="mt-2 flex items-baseline gap-x-2 grid grid-cols-2">
                    <span
                    class="text-3xl font-semibold 2xl:font-light tracking-tight text-gray-900 ">{{ EventHelper.getArticleTotal(event) | currency: "EUR" }}</span>
                    <span
                      class="text-3xl font-semibold 2xl:font-light tracking-tight text-gray-900 justify-self-end">{{ EventHelper.getArticleCount(event) }}
                    x</span>
                  </p>
                </div>
                <!-- #817 — see the phone tile above; this is the same component at desktop width. -->
                @if (EventHelper.getRevenue(event); as revenue) {
                  <app-event-revenue-tile [revenue]="revenue"/>
                } @else {
                  <div class="bg-white shadow-lg px-4 py-3 sm:px-6 lg:px-8 rounded-lg">
                    <p class="text-sm font-medium leading-6 text-gray-700">Gesamtbetrag</p>
                    <p class="mt-2 flex items-baseline gap-x-2 grid grid-cols-2">
                    <span
                      class="text-3xl font-semibold tracking-tight text-gray-900">{{ EventHelper.getEventTotal(event) | currency: "EUR" }}</span>
                    </p>
                  </div>
                }
                <div class="bg-white shadow-lg px-4 py-3 sm:px-6 lg:px-8 rounded-lg">
                  <p class="text-sm font-medium leading-6 text-gray-700">Bestseller</p>
                  <p class="mt-2 flex items-baseline gap-x-2">
                    @if (EventHelper.getCompositionValuePairs(event.normalCompositionValues)[0]) {
                      <span
                      class="text-4xl font-semibold tracking-tight text-gray-900">{{ EventHelper.getCompositionValuePairs(event.normalCompositionValues)[0].name }}</span>
                    }
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!--
          Bug #231: this list used to carry `h-50` on the <ul> and `h-100` + `!pb-32 lg:!pb-20` on each
          card's scroll area. `h-50`/`h-100` are BOOTSTRAP utilities (`height: 50%/100% !important`, from the
          globally loaded bootstrap.min.css) — not Tailwind ones — so they silently fought the layout instead
          of expressing it, and the forced bottom padding was compensation for the resulting clipping.
          The cards now size themselves with plain flex (see event-summary-card): no percentage heights, no
          `50vh`, no padding standing in for a height.
          -->
          <ul class="mx-auto grid grid-cols-1 gap-x-3 gap-y-4 pt-4 lg:grid-cols-2" role="list">
            <li app-event-summary-card
              [label]="'Verkaufspunkt: ' + (EventHelper.getEventTotal(event) | currency: 'EUR')"
              [collapsed]="views[view_index%4]!='location'"
              (next)="view_index = view_index+1">
              <svg card-icon class="bi bi-geo-alt shrink-0" height="20" viewBox="0 0 16 16" width="20"
                aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"/>
                <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
              </svg>
              <!--
                #355 (axe `definition-list` + `dlitem`): this row used to be an `<a>` wrapping the `dt`/`dd`
                pair. Only `dt`, `dd`, `div`, `script` and `template` may be DIRECT children of a `<dl>`, and a
                `dt`/`dd` pair may not live inside an `<a>` — so the card failed both rules at once, and it is
                the only one of the four that did (the other three already use a plain `<div>` row).

                The row is now that same `<div>`, and the link sits in the `<dt>` with its `::before` stretched
                over the positioned row. That keeps all three properties the old markup had: the WHOLE row —
                gap and amount included — is the click target, there is exactly ONE tab stop per row, and the
                accessible name is the location name. `group-hover:underline` on both halves reproduces the old
                row-wide `hover:underline`.

                The three colour/decoration resets are not decoration: `styles.scss` styles every `a` as a
                primary-700 link (and Bootstrap's reboot underlines it), which would repaint a label that has
                been `text-gray-500` since this card existed. `hover:text-inherit` is needed on top because
                `a:hover` there outranks a bare `text-inherit`.
              -->
              @for (value of getSortedLocationValuePairs(event.locationValues); track value.key) {
                <div class="group relative flex cursor-pointer justify-between gap-x-4 py-1">
                  <dt class="text-gray-500 fw-normal group-hover:underline">
                    <a class="no-underline text-inherit hover:text-inherit before:absolute before:inset-0
                              before:content-[''] focus-visible:outline focus-visible:outline-2
                              focus-visible:outline-offset-2 focus-visible:outline-theme-primary-500"
                      [routerLink]="[]"
                      [queryParams]="{ location: value.key }"
                      queryParamsHandling="merge">{{ value.name }}</a>
                  </dt>
                  <dd class="text-gray-700 group-hover:underline">{{ value.amount | currency: 'EUR' }}</dd>
                </div>
              }
            </li>

            <!--
              `settling` on the two COMPOSITION cards only (#716 / Task #722): they are the only two whose rows
              are re-bucketed by „Kombinationen einzeln", and therefore the only two that are briefly folded
              from the loaded page while the server's answer at the new grain is on its way. The
              „Verkaufspunkt" and „Transaktionstypen" cards below, and every hero tile above, read aggregates
              that do not depend on the grain at all — they are correct throughout and must not be marked.
            -->
            <li app-event-summary-card
              [label]="'Sonstiges: ' + (EventHelper.getOtherTotal(event) | currency: 'EUR')"
              [collapsed]="views[view_index%4]!='others'"
              [settling]="isCompositionGrainSettling"
              (next)="view_index = view_index+1">
              <svg card-icon class="bi bi-ticket-perforated shrink-0" height="20" viewBox="0 0 16 16" width="20"
                aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4 4.85v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Z"/>
                <path
                  d="M1.5 3A1.5 1.5 0 0 0 0 4.5V6a.5.5 0 0 0 .5.5 1.5 1.5 0 1 1 0 3 .5.5 0 0 0-.5.5v1.5A1.5 1.5 0 0 0 1.5 13h13a1.5 1.5 0 0 0 1.5-1.5V10a.5.5 0 0 0-.5-.5 1.5 1.5 0 0 1 0-3A.5.5 0 0 0 16 6V4.5A1.5 1.5 0 0 0 14.5 3h-13ZM1 4.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1.05a2.5 2.5 0 0 0 0 4.9v1.05a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1.05a2.5 2.5 0 0 0 0-4.9V4.5Z"/>
              </svg>
              <!--
                #534: `track other.key`, never `other.name` — in "Kombinationen einzeln" mode the same article
                appears once per swap combination, so the name is no longer unique and Angular throws on
                duplicate track keys. The key is the dictionary key the bucket was aggregated under.
              -->
              @for (other of EventHelper.getCompositionValuePairs(event.otherCompositionValues); track other.key) {
                <!--
                  No `?? []` here, unlike the wire-typed `composition.modificationLines` in the table below:
                  these rows are built by `EventHelper`, never JSON.parse'd, so the #440 normalisation already
                  happened at aggregation time and the array is a real one. It is EMPTY in combined mode by
                  design — a merged bucket spans several swap combinations and has no single wording.
                -->
                @let otherLines = other.modificationLines;
                <div class="flex justify-between gap-x-4 py-1">
                  <dt class="min-w-0 text-gray-500 fw-normal">{{ other.count }}x&nbsp;{{ other.name }}
                    @if (otherLines.length > 0) {
                      <span class="modification-lines mt-1 text-xs leading-5 text-gray-500 block">
                        @for (line of otherLines; track $index) {
                          <span class="modification-line block">
                            <span class="modification-connector">{{ line.connector }}</span>{{ line.text }}
                          </span>
                        }
                      </span>
                    }
                  </dt>
                  <dd class="shrink-0 text-gray-700">{{ other.amount | currency: 'EUR' }}</dd>
                </div>
              }
            </li>

            <li app-event-summary-card
              [label]="'Transaktionstypen: ' + (EventHelper.getEventTotal(event) | currency: 'EUR')"
              [collapsed]="views[view_index%4]!='payment'"
              (next)="view_index = view_index+1">
              <svg card-icon class="bi bi-wallet shrink-0" height="20" viewBox="0 0 16 16" width="20"
                aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5V3zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a1.99 1.99 0 0 1-1-.268zM1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1z"/>
              </svg>
              @for (value of EventHelper.getBookingValuePairs(event.bookingValues); track value.type) {
                <div class="flex justify-between gap-x-4 py-1">
                  <dt class="text-gray-500 fw-normal">{{ value.count }}
                    x {{ value.type }}
                  </dt>
                  <dd class="text-gray-700">{{ value.amount | currency: 'EUR' }}</dd>
                </div>
              }
            </li>

            <li app-event-summary-card
              [label]="'Artikel: ' + EventHelper.getArticleCount(event)"
              [collapsed]="views[view_index%4]!='drinks'"
              [settling]="isCompositionGrainSettling"
              (next)="view_index = view_index+1">
              <svg card-icon class="bi bi-cup-straw shrink-0" height="20" viewBox="0 0 16 16" width="20"
                aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.902.334a.5.5 0 0 1-.28.65l-2.254.902-.4 1.927c.376.095.715.215.972.367.228.135.56.396.56.82 0 .046-.004.09-.011.132l-.962 9.068a1.28 1.28 0 0 1-.524.93c-.488.34-1.494.87-3.01.87-1.516 0-2.522-.53-3.01-.87a1.28 1.28 0 0 1-.524-.93L3.51 5.132A.78.78 0 0 1 3.5 5c0-.424.332-.685.56-.82.262-.154.607-.276.99-.372C5.824 3.614 6.867 3.5 8 3.5c.712 0 1.389.045 1.985.127l.464-2.215a.5.5 0 0 1 .303-.356l2.5-1a.5.5 0 0 1 .65.278zM9.768 4.607A13.991 13.991 0 0 0 8 4.5c-1.076 0-2.033.11-2.707.278A3.284 3.284 0 0 0 4.645 5c.146.073.362.15.648.222C5.967 5.39 6.924 5.5 8 5.5c.571 0 1.109-.03 1.588-.085l.18-.808zm.292 1.756C9.445 6.45 8.742 6.5 8 6.5c-1.133 0-2.176-.114-2.95-.308a5.514 5.514 0 0 1-.435-.127l.838 8.03c.013.121.06.186.102.215.357.249 1.168.69 2.438.69 1.27 0 2.081-.441 2.438-.69.042-.029.09-.094.102-.215l.852-8.03a5.517 5.517 0 0 1-.435.127 8.88 8.88 0 0 1-.89.17zM4.467 4.884s.003.002.005.006l-.005-.006zm7.066 0-.005.006c.002-.004.005-.006.005-.006zM11.354 5a3.174 3.174 0 0 0-.604-.21l-.099.445.055-.013c.286-.072.502-.149.648-.222z"/>
              </svg>
              <!--
                #534: the ONE "Anzeigeoptionen" gear on this page. Its panel holds the "Kombinationen einzeln"
                switch, which writes the shared preference — so the "Sonstiges" card, the phone/desktop hero
                tiles and the "Bestseller" tile follow along for free; they all read the same two dictionaries,
                which the component re-buckets on mode change. A gear rather than a bare switch because the
                setting needs a sentence of explanation that no card header has room for.
              -->
              <app-composition-grouping-settings card-actions id="event-details-grouping-settings"/>
              <!-- `track composition.key`: see the "Sonstiges" card above — the name is not unique per row. -->
              @for (
                composition of EventHelper.getCompositionValuePairs(event.normalCompositionValues); track composition.key) {
                <!-- Aggregated by `EventHelper`, so already a real array — see the "Sonstiges" card above. -->
                @let articleLines = composition.modificationLines;
                <div class="flex justify-between gap-x-4 py-1">
                  <dt class="min-w-0 text-gray-500 fw-normal">{{ composition.name }}
                    @if (articleLines.length > 0) {
                      <span class="modification-lines mt-1 text-xs leading-5 text-gray-500 block">
                        @for (line of articleLines; track $index) {
                          <span class="modification-line block">
                            <span class="modification-connector">{{ line.connector }}</span>{{ line.text }}
                          </span>
                        }
                      </span>
                    }
                  </dt>
                  <dd class="shrink-0 text-gray-700">{{ composition.count }}</dd>
                </div>
              }
            </li>
          </ul>

          <div class="">
            <!--<div class="sm:flex sm:items-center">
            <div class="sm:flex-auto">

            </div>
            <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
              <button type="button" class="block rounded-md bg-theme-primary-700 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-theme-primary-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-700">Export</button>
            </div>
          </div>-->
          <div class="mt-8 flow-root">
            <div class=" -my-2 overflow-x-auto">
              <div class="inline-block min-w-full py-2 align-middle">
                <table class="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th class="whitespace-nowrap py-3.5 pl-2 pr-3 text-left text-sm font-semibold text-gray-900"
                        scope="col">Artikel
                      </th>
                      <th class="whitespace-nowrap py-3.5 pl-2 pr-3 text-left text-sm font-semibold text-gray-900"
                        scope="col">Beleg
                      </th>
                      <th
                        class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 hidden sm:table-cell"
                        scope="col">
                        Einzelpreise
                      </th>
                      <th class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                        scope="col">
                        <app-sorting-indicator (click)="SetSorting(Sorting.Price)" [currentSorting]="SortedBy"
                          [inverseState]="Inverse"
                          [thisSorting]="Sorting.Price"
                        displayName="Gesamt"></app-sorting-indicator>
                      </th>
                      <th class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900" scope="col">
                        Verkaufspunkt
                      </th>
                      <th
                        class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 hidden md:table-cell"
                        scope="col">
                        Profil
                      </th>
                      <th class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
                        scope="col">
                        <app-sorting-indicator (click)="SetSorting(Sorting.Date)"
                          [currentSorting]="SortedBy" [inverseState]="Inverse"
                          [thisSorting]="Sorting.Date"
                        displayName="Zeit"></app-sorting-indicator>
                      </th>
                      <th
                        class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 hidden xl:table-cell"
                        scope="col">
                        Transaction ID
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200 bg-white">
                    @for (order of event.orders; track order.id) {
                      <tr [class.bg-gray-200]="order.bookingType == N5BookingType.Employee">
                        <td class="whitespace-nowrap py-2 pl-2 pr-3 text-sm text-gray-500">
                          @for (composition of order.compositions; track composition.id) {
                            <!--
                              #440: `undefined.length` threw here on every change-detection pass, against a
                              payload that did not carry `modificationLines` at all. The `?? []` guard that fixed
                              it has MOVED, at Feature #760 — not disappeared: `EventHttpService` normalises the
                              payload once, where the wire meets the client, instead of once per change-detection
                              pass in a template. So this dereference is safe, and it is safe for every other
                              consumer too rather than only for the template that remembered to write a guard.
                              Do not put the `?? []` back: the field is required on the response DTO, so the
                              Angular compiler answers NG8102, and the runtime defence belongs at the boundary.
                              The `@let` stays — the `@if` and the `@for` below read the same array.
                            -->
                            @let modificationLines = composition.modificationLines;
                            <p>
                              <span>{{ composition.quantity }}x&nbsp;</span>
                              <span>{{ composition.composition.name }}</span>
                              @if (modificationLines.length > 0) {
                                <span class="modification-lines mt-1 text-xs leading-5 text-gray-500 block">
                                  @for (line of modificationLines; track $index) {
                                    <span class="modification-line block">
                                      <span class="modification-connector">{{ line.connector }}</span>{{ line.text }}
                                    </span>
                                  }
                                </span>
                              }
                            </p>
                          }
                        </td>
                        <td class="pl-2">
                          @if (order.receipt) {
                            <a [href]="order.receipt"
                              class="bg-red-300 text-theme-primary-700 hover:text-theme-primary-900 select-none text-center"
                              target="_blank">
                              <span>
                                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M8 21H4a1 1 0 0 1-1-1v-4a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h4a1 1 0 0 0 0-2m14-6a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 0 0 2h4a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1M20 1h-4a1 1 0 0 0 0 2h4a1 1 0 0 1 1 1v4a1 1 0 0 0 2 0V4a3 3 0 0 0-3-3M2 9a1 1 0 0 0 1-1V4a1 1 0 0 1 1-1h4a1 1 0 0 0 0-2H4a3 3 0 0 0-3 3v4a1 1 0 0 0 1 1m8-4H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1M9 9H7V7h2Zm5 2h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1m1-4h2v2h-2Zm-5 6H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-1 4H7v-2h2Zm5-1a1 1 0 0 0 1-1a1 1 0 0 0 0-2h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1m4-3a1 1 0 0 0-1 1v3a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-4 4a1 1 0 1 0 1 1a1 1 0 0 0-1-1"
                                    />
                                </svg>
                              </span>
                            </a>
                          }
                        </td>
                        <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 hidden sm:table-cell">
                          <div class="flex flex-col">
                            @for (composition of order.compositions; track composition.id) {
                              <p class="inline-flex space-x-2">
                                <span class="size-4 place-self-center text-yellow-600">
                                  <svg [class.hidden]="!composition.isCustomized" xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 256 256"
                                    class="cursor-help"
                                    [matTooltip]="composition.description" matTooltipPosition="left"
                                    matTooltipClass="multi-line-tooltip">
                                    <path
                                      d="M230.91 172a8 8 0 0 1-2.91 10.91l-96 56a8 8 0 0 1-8.06 0l-96-56A8 8 0 0 1 36 169.09l92 53.65l92-53.65a8 8 0 0 1 10.91 2.91M220 121.09l-92 53.65l-92-53.65a8 8 0 0 0-8 13.82l96 56a8 8 0 0 0 8.06 0l96-56a8 8 0 1 0-8.06-13.82M24 80a8 8 0 0 1 4-6.91l96-56a8 8 0 0 1 8.06 0l96 56a8 8 0 0 1 0 13.82l-96 56a8 8 0 0 1-8.06 0l-96-56A8 8 0 0 1 24 80m23.88 0L128 126.74L208.12 80L128 33.26Z"/>
                                  </svg>
                                </span>
                                <span [class.text-red-600]="composition.isSpecial"
                                  class="place-self-center">
                                  {{ composition.price | currency: "EUR" }}
                                </span>
                              </p>
                            }
                          </div>
                        </td>
                        <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                          <div class="flex flex-col">
                            @for (pair of getBookingValuePairs(order.bookingValues); track pair.key) {
                              <div class="inline-flex"
                                (click)="transaction_copyForeignId(order)"
                                [class.text-theme-primary-700]="pair.key == 1 && order.foreignTransactionId"
                                [class.hover:text-theme-primary-900]="pair.key == 1 && order.foreignTransactionId"
                                [class.cursor-pointer]="pair.key == 1 && order.foreignTransactionId">
                                @if (pair.key == 0) {
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                    class="bi bi-cash-coin mr-2 place-self-center" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                      d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"/>
                                    <path
                                      d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z"/>
                                    <path
                                      d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z"/>
                                    <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z"/>
                                  </svg>
                                }
                                @if (pair.key == 1) {
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                    class="bi bi-credit-card-2-back-fill mr-2 place-self-center"
                                    viewBox="0 0 16 16">
                                    <path
                                      d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5H0V4zm11.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2zM0 11v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1H0z"/>
                                  </svg>
                                }
                                @if (pair.key == 2) {
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                    class="bi bi-person-circle mr-2 place-self-center"
                                    viewBox="0 0 16 16">
                                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                                    <path fill-rule="evenodd"
                                      d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
                                  </svg>
                                }
                                <span class="place-self-center w-full">
                                  <p class="text-right">{{ pair.amount | currency: "EUR" }}</p>
                                </span>
                              </div>
                            }
                          </div>
                        </td>
                        <td
                          [queryParams]="{ location: order.location.id }"
                          [routerLink]="[]"
                          class="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 cursor-pointer hover:text-theme-primary-700"
                          queryParamsHandling="merge">{{ order.location.name }}
                        </td>
                        <td
                          class="whitespace-nowrap px-2 py-2 text-sm text-gray-900 hidden md:table-cell">{{ order.configuration.name }}
                        </td>
                        <td
                          class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">{{ (order.created) | date : "dd.MM.yyyy, HH:mm" }}
                        </td>
                        <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 hidden xl:table-cell">{{ order.id }}
                        </td>
                      </tr>
                    }

                    <!-- More transactions... -->
                  </tbody>
                </table>
              </div>
            </div>

            <!--
              #716: the table is a PAGE of the newest transactions, not the whole event. The four tiles above
              are server-side aggregates over the whole event and do NOT move with this control — which is the
              entire reason the list may be bounded at all.

              Stacked on a phone and laid out in a row from `sm:` up, per the responsive rule in CLAUDE.md; the
              picker is width-capped so it cannot push the row wider than a narrow viewport.
            -->
            <div class="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <p class="text-sm text-gray-500" data-testid="order-count">
                @if (isOrderListBounded) {
                  Es werden die neuesten {{ loadedOrderCount }} von {{ totalOrderCount }} Transaktionen angezeigt.
                } @else {
                  {{ totalOrderCount }} {{ totalOrderCount === 1 ? 'Transaktion' : 'Transaktionen' }}
                }
              </p>
              <div class="flex items-center gap-2">
                <label class="whitespace-nowrap text-sm text-gray-500" for="event-details-page-size">
                  Angezeigte Transaktionen
                </label>
                <!--
                  `cqme-select`, never a native `<select>`: a native one lets type-ahead read out option
                  values, and the design system's control is the documented pattern (style guide).
                -->
                <div class="w-28 shrink-0">
                  <cqme-select (currentChange)="pageSize_change($event)" [current]="pageSize"
                               [labelKey]="'label'" [options]="pageSizeOptions" [valueKey]="'value'"
                               ariaLabel="Angezeigte Transaktionen" data-testid="page-size"
                               id="event-details-page-size"/>
                </div>
              </div>
            </div>

            <!--
              Task #755: name the cost of „Alle" BEFORE it is picked, for a large event. `tone="info"` — this
              states a plain fact about the event's size, not a refusal or a coerced choice (see the style
              guide's inline-notice tone table). Placed below the count/picker row it explains, full width, per
              the same placement rule forms use for a notice about the row above it.

              Deliberately no byte estimate: the measured ~1.1 MB/12.9 MB numbers are from ONE seeded event and
              do not generalise to an arbitrary one, so the notice names only the real, server-reported
              transaction count.
            -->
            @if (showAllPageSizeNotice) {
              <cqme-inline-notice class="mt-3" data-testid="all-page-size-notice" id="event-details-all-page-size-notice"
                                   tone="info">
                Dieses Event hat {{ totalOrderCount }} Transaktionen. „Alle" lädt sie alle auf einmal und
                braucht dafür mehr Zeit.
              </cqme-inline-notice>
            }
          </div>
        </div>
      </div>
    }
  </layout-page-scrollable>
</layout-page-container>

<!-- employee sales popup -->
@if (employeeSales_isOpen && PermissionService.CheckPermission(PermissionService.Inventory_Event_GetEmployeeOrders())) {

  <div class="absolute inset-0 z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
    From: "opacity-0"
    To: "opacity-100"
    Leaving: "ease-in duration-200"
    From: "opacity-100"
    To: "opacity-0"
    -->
    <div class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

    <div class="absolute inset-0 z-10 overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
        <div
          class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-3 text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-lg sm:p-6">
          <div>
            <div class="grid grid-cols-1 border-b-2 border-gray-400 content-center pb-2">
              <div class="flex">
                <p class="fw-bold text-lg place-self-center">Mitarbeiterartikel Übersicht</p>
              </div>
            </div>
            @if (employeeSales_data!.length == 0) {
              <div class="pt-2">
                <span>Keine Einträge.</span>
              </div>
            }
            @for (employee of employeeSales_data; track $index) {
              <div class="grid grid-cols-2 border-b-2 py-2">
                <span class="text-black">{{ employee.firstName }} {{ employee.lastName }}<br><span
                class="fw-bold">{{ employee.total | currency: "EUR" }}</span></span>
                <div class="text-left">
                  @for (order of employee.orders; track order.id) {
                    <div class="grid grid-cols-1">
                      @for (composition of order.compositions; track composition.id) {
                        <!-- #440: optional on the wire — normalised with `?? []`, see the "Artikel" column above. -->
                        @let modificationLines = composition.modificationLines ?? [];
                        @if ((employee.orders.indexOf(order) == 0 && order.compositions.indexOf(composition) == 0 && !employee.details) || employee.details) {
                          <div
                            >
                            <span>{{ composition.quantity }}
                              x {{ composition.composition.name }}
                            </span>
                            @if (modificationLines.length > 0) {
                              <div class="modification-lines text-gray-500 fw-normal text-left">
                                @for (line of modificationLines; track $index) {
                                  <div class="modification-line">
                                    <span class="modification-connector">{{ line.connector }}</span>{{ line.text }}
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                      }
                    </div>
                  }
                  @if ((employee.orders.length > 1 || employee.orders[0].compositions.length > 1) && !employee.details) {
                    <div
                      >
                      <a class="text-theme-primary-700 hover:text-theme-primary-900 cursor-pointer select-none"
                      (click)="employee.details = true">Alle anzeigen</a>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <div class="mt-5 sm:mt-6 sm:grid grid-cols-1 sm:gap-3">
            <button (click)="employeeSales_close()" type="button"
              class="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0">
              Schließen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (locationConfig_isOpen && PermissionService.CheckPermission(PermissionService.CombinedPermission_EventReadLocationConfig())) {
  <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
    From: "opacity-0"
    To: "opacity-100"
    Leaving: "ease-in duration-200"
    From: "opacity-100"
    To: "opacity-0"
    -->
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

    <div class="fixed inset-0 z-10 overflow-y-auto lg:pl-72">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
        <div
          class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-3 text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-lg sm:p-6">
          <div>
            <div class="grid grid-cols-2 border-b-2 border-gray-400 content-center pb-2">
              <div class="flex">
                <p class="fw-bold text-lg place-self-center">Verkaufspunkt Konfiguration</p>
              </div>
              <div class="w-full p-0.5 bg-yellow-400 rounded-md self-start">
                <select
                  [disabled]="!PermissionService.CheckPermission(PermissionService.CombinedPermission_EventSetLocationConfig())"
                  [ngModel]="locationConfig_generalConfiguration"
                  (ngModelChange)="locationConfig_generalConfigurationChanged($event)"
                  class="w-full p-1">
                  <option selected [ngValue]="undefined">---</option>
                  @for (configuration of locationConfig_configurations; track configuration.id) {
                    <option class="ring-1 ring-yellow-300 border border-yellow-300"
                      [ngValue]="configuration">{{ configuration.name }}
                    </option>
                  }
                </select>
              </div>
            </div>
            @for (location of locationConfig_data; track $index; let index = $index) {
              <div class="grid grid-cols-2">
                <span class="text-black">{{ location.location.name }}</span>
                <select
                  [disabled]="!PermissionService.CheckPermission(PermissionService.CombinedPermission_EventSetLocationConfig())"
                  class="p-1" [(ngModel)]="locationConfig_data![index].configuration">
                  <option selected [value]="undefined">---</option>
                  @for (configuration of locationConfig_configurations; track configuration.id) {
                    <option [ngValue]="configuration">{{ configuration.name }}
                    </option>
                  }
                </select>
              </div>
            }
          </div>
          <div class="mt-5 sm:mt-6 sm:grid grid-cols-1 sm:grid-cols-2 sm:gap-3">
            <button (click)="locationConfig_close()" type="button"
              class="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0">
              Cancel
            </button>
            @if (PermissionService.CheckPermission(PermissionService.CombinedPermission_EventSetLocationConfig())) {
              <button
                (click)="locationConfig_save()" type="button"
                class="mt-2 sm:!mt-0 inline-flex w-full justify-center rounded-md bg-theme-primary-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-theme-primary-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-700">
                Save
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}

<app-supplier-popup (selectedChange)="download($event)" [(visible)]="supplierPopup_isVisible"></app-supplier-popup>
